import axios from 'axios';
import useUserStore from '../store/useUserStore';
const { user } = useUserStore.getState();
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL, // set your base API URL
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 10000,
});

// Add request interceptor to inject dynamic DB header
axiosInstance.interceptors.request.use(
    (config) => {
        const { user } = useUserStore.getState();
        if (user.db) {
            config.headers['db'] = user.db;
        }
        return config;
    },
    (error) => Promise.reject(error)
);
const tdraxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_TDR_API_URL, // set your base API URL
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 10000,
});

export { axiosInstance, tdraxiosInstance };